import { useModal } from '@ebay/nice-modal-react'
import { styled } from '@linaria/react'
import { useNavigate } from '@tanstack/router'
import { useTranslation } from 'react-i18next'

import useGeoCheck from '../../hooks/useGeoCheck'
import LoginModal from '../common/log-in-modal'

const Container = styled.div`
  margin-bottom: 50px;
`

const SignUp = styled.div`
  color: var(--txt);
  text-transform: uppercase;
  font-size: 14px;
  white-space: nowrap;
  position: relative;
  svg {
    margin-right: 8px;
    margin-top: -3px;
    fill: var(--txt);
  }
`

const Login = styled.button`
  width: 260px;
  padding: 12px 32px;
  border-radius: 6px;
  background: #00a6ff;
  text-transform: uppercase;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 15px;
`
const TabLabel = styled.p`
  color: #00a6ff;
  text-decoration: underline;
`
type LoginSignUpProps = {
  closeProfileDrawer: () => void
}

const LoginSignUp = ({ closeProfileDrawer: closeModal }: LoginSignUpProps) => {
  const { t } = useTranslation('common')
  const logInModal = useModal(LoginModal)
  const navigate = useNavigate()
  const { geoCheck } = useGeoCheck()

  return (
    <Container className="v-flx-ctr">
      <button
        onClick={() => {
          geoCheck(logInModal.show)
          closeModal()
        }}>
        <Login onClick={closeModal}>{t('login')}</Login>
      </button>
      <SignUp
        className="flx-ctr"
        onClick={() => {
          geoCheck(() => navigate({ to: '/register' }))
          closeModal()
        }}>
        <TabLabel>{t('register')}</TabLabel>
      </SignUp>
    </Container>
  )
}

export default LoginSignUp
